/** SessionStorage key for one-shot labor messages when leaving Pre-Pack (same pattern as Clamp QC list flash). */
export const PREPACK_LABOR_FLASH_STORAGE_KEY = "prepack_labor_flash_message";
